import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../../config.json';
import UserLabel from './userLabel';

const apiUrl = config.apiUrl;

const UserUpdateRole = () => {
    const [userData, setUserData] = useState({
        LastName: '',
        FirstName: '',
        MiddleName: '',
        Email: '',
        CompanyCode: '',
        RoleId: '',
    });

    const [roleList, setRoleList] = useState([]);

    const { userId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        View: roles?.includes('View') || false,
        Admin: roles?.includes('Admin') || false,
        Approver: roles?.includes('Approver') || false,
        Standard: roles?.includes('Standard') || false,
    };

    const { Admin } = userAccess;

    const handleInputChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiUrl}/User/${userId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch user data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();
                setUserData({
                    FirstName: data.User[0].FirstName,
                    MiddleName: data.User[0].MiddleName,
                    LastName: data.User[0].LastName,
                    Email: data.User[0].Email,
                    CompanyCode: data.User[0].UserCompany.CompanyCode,
                    RoleId: data.User[0].Role.Id,
                });
            } catch (error) {
                setErrorMessage('Error fetching user data');
                setSuccessMessage('');
            }
        };

        const fetchRoleList = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Role`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch role data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();

                setRoleList(data.Role);
            } catch (error) {
                setErrorMessage('Error fetching role data');
                setSuccessMessage('');
                return;
            }
        };

        fetchData();
        fetchRoleList();
    }, [userId]);

    const handleForUpdate = async (e) => {
        e.preventDefault();

        try {

            const token = localStorage.getItem('token');
            const response = await fetch(`${apiUrl}/User/UpdateUserRole/${userId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(userData), // Pass the whole userData object
            });

            if (response.ok) {
                const data = await response.json();
                setErrorMessage('');
                setSuccessMessage(data.Message);
                navigate('/user-list');
            } else {
                setErrorMessage('Update user role error!');
                setSuccessMessage(''); // Display error message if the response is not okay
                return;
            }
        } catch (error) {
            setErrorMessage('Error updating user');
            setSuccessMessage('');
            return;
        }
    };


    const {
        LastName,
        FirstName,
        MiddleName,
        Email,
        RoleId,
        CompanyCode,
    } = userData;
    return (
        <div>
            {userAccess.Admin ? (
                <>
                    <h3>Update User Role</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForUpdate}>
                        <div className="row mt-4">
                            <UserLabel label="Last Name" value={LastName} />
                            <UserLabel label="First Name" value={FirstName} />
                            <UserLabel label="Middle Name" value={MiddleName} />
                            <UserLabel label="Email" value={Email} />
                            <UserLabel label="Company Code" value={CompanyCode} />
                            <div className="mb-2">
                                <label htmlFor='roleID' className='form-label'>Role</label>
                                <select
                                    className="form-control custom-width"
                                    id="roleID"
                                    name="RoleId"
                                    value={RoleId}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option key="default" value="">---Select role---</option>
                                    {roleList.map((role) => (
                                        <option key={role.ID} value={role.ID}>
                                            {`${role.RoleName}`}
                                        </option>
                                    ))}
                                </select>


                            </div>
                            <div className="mb-2">
                                <Link to="/user-list" className="btn btn-secondary me-2">Back</Link>
                                {userAccess.Admin && (
                                    <button type="submit" className="btn btn-primary">Save</button>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserUpdateRole;
